module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-78-min.0e1b55f5.jpg";